






























































import FeedbackComponent from '@/components/base/FeedbackComponent'
import CRMContactAttachments from "@/components/dashboard/concentration-of-inquiries/tabs/CRMContactAttachments.vue";
import CRMContactAttachmentsMember
  from "@/components/dashboard/concentration-of-inquiries/tabs/CRMContactAttachmentsMember.vue";
import CustomerServiceCRMContactGeneralDetails
  from "@/components/dashboard/concentration-of-inquiries/tabs/CustomerServiceCRMContactGeneralDetails.vue";
import CustomerServiceHistoryGrid
  from "@/components/dashboard/concentration-of-inquiries/tabs/CustomerServiceHistoryGrid.vue";
import EditCRMContact from "@/components/dashboard/concentration-of-inquiries/tabs/EditCRMContact.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {CrmFilterType} from "@/models/CrmFilterType";
import {EmployerCRMDetails, MemberCRMDetails} from "@/store/modules/customerService";
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({
  components: {
    CustomerServiceCRMContactGeneralDetails,
    CustomerServiceHistoryGrid,
    CRMContactAttachments,
    EditCRMContact,
    CRMContactAttachmentsMember
  }
})
export default class ConcentrationOfInquiriesModal extends FeedbackComponent {

  @Prop(Number) crmId!: number;
  @Prop(String) uniqueIdentifier!: string;
  @Prop(Boolean) member!: boolean;

  @Action('getMemberDetails', StoreNamespace.CUSTOMER_SERVICE) getMemberDetails: any;
  @Action('getEmployerDetailsByCRMId', StoreNamespace.CUSTOMER_SERVICE) getEmployerDetailsByCRMId: any;
  @Action('getConfigCRMDetails', StoreNamespace.CUSTOMER_SERVICE) getConfigCRMDetails: any;


  private memberCRMDetails: MemberCRMDetails | null = null;
  private employerCRMDetails: EmployerCRMDetails | null = null;
  private memberAccounts: any[] = []
  private crmFilterType : CrmFilterType | null = null
  private companyLevelCrm: any = {}


  created() {
    this.memberCRMDetails = null
    this.employerCRMDetails = null

    this.getConfigCRMDetails({
      requestorCallback: this
    })

    if (this.member) {
      this.crmFilterType = CrmFilterType.MEMBER
      this.getMemberDetails({
        pathVariable: this.uniqueIdentifier,
        requestorCallback: this
      })
    } else {
      this.crmFilterType = CrmFilterType.EMPLOYER
      this.getEmployerDetailsByCRMId({
        pathVariable: this.crmId,
        requestorCallback: this
      });
    }
  }



  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'getMemberDetails':
        this.memberCRMDetails = data;
        this.memberAccounts = []
        if (this.memberCRMDetails) {
          this.memberAccounts = this.memberCRMDetails.accountsList
        }
        break;
      case 'getEmployerDetailsByCRMId':
        this.employerCRMDetails = data
        break;

      case 'crmConfigurationManagement/getConfigCRMDetails':
        this.companyLevelCrm = data.companyLevelCrm
        break;
    }
  }

  onSubmitEdit() {
    this.$emit('onSubmitEdit');
  }
}


